import type { TmWrappers } from '@/wrappers'
import { useWrapper } from '@/composition/modal'
import type { NumberGiftType } from '@/services/domain/services/regulations/types'

interface GettingStartedChooseYourTextingNumberModalParams {
  giftType: NumberGiftType
  localNumberPrice: number
}

export const useGettingStartedChooseYourTextingNumberModal = () => {
  const wrapperId: TmWrappers = 'gettingStartedChooseYourTextingNumberModal'

  const open = (params: GettingStartedChooseYourTextingNumberModalParams) => {
    useWrapper<GettingStartedChooseYourTextingNumberModalParams>(wrapperId).open(params)
  }

  const getParams = () => {
    return useWrapper<GettingStartedChooseYourTextingNumberModalParams>(wrapperId).getParams()
  }

  return {
    open,
    getParams,
  }
}
